import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { statusUpdateAfterReportGeneration } from 'services/apiOrders';

const useStatusConfirm = () => {
  const queryClient = useQueryClient();

  const{isPending:isChanging, isSuccess:isChanged, mutate:updateFinalStatus} = useMutation({
    mutationFn: statusUpdateAfterReportGeneration,
    onSuccess:()=>{
      // toast.success("Order Completed")
      queryClient.invalidateQueries(['orderList'])
    },
    onError:(error)=>{
      console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return {isChanging, isChanged, updateFinalStatus}
}

export default useStatusConfirm